import React from 'react';
import { Box, Typography, Paper, Button, Chip } from '@mui/material';
import { School, ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const DashboardBanner: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -60,
          right: -60,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -80,
          left: -80,
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
        }}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 1, flexWrap: 'wrap' }}>
        <School sx={{ fontSize: 40 }} />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            Ознакомьтесь с инструкцией по работе
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Быстрый старт работы с системой управления экскурсоводами
          </Typography>
        </Box>
        <Button
          variant="contained"
          endIcon={<ArrowForward />}
          onClick={() => navigate('/help')}
          sx={{
            bgcolor: 'white',
            color: '#1976d2',
            fontWeight: 'bold',
            borderRadius: 2,
            px: 3,
            '&:hover': {
              bgcolor: '#f5f5f5',
            },
          }}
        >
          К инструкции
        </Button>
      </Box>
    </Paper>
  );
};

export default DashboardBanner;
